import { trTR } from '@mui/material/locale';
import { ThemeOptions, createTheme } from '@mui/material/styles';

const primary = '#2EB0A2';
const secondary = '#4263c1';
// const info = lime;

export const common: ThemeOptions = {
  typography: {
    fontFamily: 'Config, Regular',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: 'unset' } },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: '0.9rem',
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          '& .span': {
            fontSize: '0.9rem',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          lineHeight: '33px',
          '& input': {
            height: 'auto',
          },
          fontSize: '1rem',
          '& fieldset': {
            borderColor: '#EEE',
            borderWidth: 2,
          },
          '& :hover ': {
            borderColor: 'green',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          textTransform: 'none',
          lineHeight: '33px',
          borderRadius: '10px',
        },
      },
    },
  },
};

export const makeTheme = (opts: ThemeOptions) =>
  createTheme(
    {
      ...common,
      ...opts,
    },
    trTR,
  );

export const darkTheme = makeTheme({
  components: {
    ...common.components,
    MuiPaper: {
      styleOverrides: {
        root: {
          //border: '1px solid #122F4B',
        },
      },
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: primary,
    },
    secondary: {
      main: secondary,
    },
    background: {
      default: '#071A2C',
      paper: '#001E3C',
    },
  },
});

export const lightTheme = makeTheme({
  components: {
    ...common.components,
    MuiPaper: {
      styleOverrides: {
        root: {
          border: '1px solid #f1f3f0',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          // color: grey[800],
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          // color: grey[800],
        },
      },
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: primary,
    },
    secondary: {
      main: secondary,
    },
    background: {
      default: '#F7F9FC',
      paper: '#fff',
    },
    contrastThreshold: 2,
  },
});
